import TablePopoverMixin from "./table-popover-mixin"
import paginate from "@/filters/paginate"
import { toRaw } from 'vue';

export default {
  filters: {
    paginate,
  },
  mixins: [
    TablePopoverMixin,
  ],
  data() {
    return {
      page: {
        current: 1,
        size: 10,
        total: null,
      },
    }
  },
  computed: {
    paginateData() {
      let {current, size} = this.page
      let items = JSON.parse(JSON.stringify(this.items))
      if (!size) return items
      let from = (current - 1) * size
      let till = current * size
      return toRaw(items).slice(from, till)
    }
  }
}
